var React = require('react');

function IconLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.0089 12.8661C29.497 13.3543 29.497 14.1457 29.0089 14.6339L19.2678 24.375L29.0089 34.1161C29.497 34.6043 29.497 35.3957 29.0089 35.8839C28.5207 36.372 27.7293 36.372 27.2411 35.8839L16.6161 25.2589C16.128 24.7707 16.128 23.9793 16.6161 23.4911L27.2411 12.8661C27.7293 12.378 28.5207 12.378 29.0089 12.8661Z"}));
}

IconLeft.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = IconLeft;

IconLeft.default = IconLeft;
